// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1FoUP","info":"UpdateTermsInfo_info__1oVtt"};